// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "assets/e5de00b2/" + chunkId + "." + __webpack_require__.h() + ".ve5de00b2.js";
};